import { ACCESS_CARD, ORG_ACCESS_CARDS, REMOVE_ACCESS_CARDS } from "services/apiURl";
import { commonHeaders, getRequest, postRequest } from "services/httpHelper";

export const getAccessCard = async (accessId, accessCode, orgId, language, clearOthers = false) => {
  try {
    const clearParam = clearOthers ? "&clear_others=true" : "";
    const response = await getRequest({
      url: `${ACCESS_CARD}?access_id=${accessId}&access_code=${accessCode}&org_id=${orgId ? orgId : ""}&language=${language}${clearParam}`,
      headers: commonHeaders
    });
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "An unexpected error occurred";

    return { error: errorMessage };
  }
};

export const removeAccessCard = async (accessId, accessCode) => {
  try {
    const response = await getRequest({
      url: `${ACCESS_CARD}?access_id=${accessId}&access_code=${accessCode}&remove=true`,
      headers: commonHeaders
    });
    return response;
  } catch (error) {
    console.error("Error deleting access card:", error);
    throw error;
  }
};

export const getOrgAccessCards = async () => {
  try {
    const response = await getRequest({
      url: `${ORG_ACCESS_CARDS}`,
      headers: commonHeaders
    });
    return response;
  } catch (error) {
    console.error("Error getting org access cards:", error);
    throw error;
  }
};

export const removeAccessCardsBulk = async (accessUids) => {
  try {
    const response = await postRequest({
      url: `${REMOVE_ACCESS_CARDS}`,
      headers: commonHeaders,
      data: { access_uids: accessUids }
    });
    return response;
  } catch (error) {
    console.error("Error removing access cards:", error);
    throw error;
  }
};
